import { render, staticRenderFns } from "./DashboardViewComplain.vue?vue&type=template&id=22c7d7a2"
import script from "./DashboardViewComplain.vue?vue&type=script&lang=js"
export * from "./DashboardViewComplain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports